export function getHelpCenterLink({
  key = 'home',
  config,
  locale = 'EN',
  companyName = 'shore',
}: {
  key: string;
  locale: string;
  companyName: string;
  config: Record<string, Record<string, string>>;
}) {
  switch (companyName) {
    case 'shore':
      return (
        config?.helpcenter?.[key]?.replace(
          '__locale__',
          locale.toLowerCase()
        ) ?? ''
      );
    case 'localsearch':
      return 'https://cc.localsearch.ch/s/help?language=de&topic=Product_related_questions_NV&subtopic=MyCOCKPIT_booking_system_NV';
    default:
      return null;
  }
}

export const isTrialPhasePromoActive = ({
  companyName,
  trialDaysLeft,
  roles,
}: {
  companyName: string;
  trialDaysLeft: number;
  roles: string[];
}) =>
  companyName === 'shore' &&
  trialDaysLeft !== 0 &&
  (roles.includes('admin') || roles.includes('owner'));

export const isUpsellShorePOSActive = ({
  locale,
  companyName,
  packageCodes,
}: {
  locale: string;
  companyName: string;
  packageCodes: string[];
}) => {
  if (companyName !== 'shore') {
    return false;
  }

  const availableLocales = ['en', 'de', 'de-CH', 'es'];

  if (availableLocales.indexOf(locale) === -1) {
    return false;
  }

  if (
    packageCodes.includes('shore_basic') ||
    packageCodes.includes('shore_plus')
  ) {
    return true;
  }

  if (packageCodes.length === 0) {
    return true;
  }

  return false;
};

export const isShorePOSExternalLinkActive = ({
  companyName,
  packageCodes,
}: {
  companyName: string;
  packageCodes: string[];
}): boolean => {
  if (companyName !== 'shore') {
    return false;
  }

  if (packageCodes.includes('shore_pos_premium')) {
    return true;
  }

  return false;
};

export const isWhitelabelAccount = (whiteLabel: string | null): boolean => {
  return whiteLabel !== null && whiteLabel !== 'shore';
};

export const isResellerAccount = (
  subscriptionPartner: string | null
): boolean => {
  const resellers = ['kreativmedia', 'herold'];
  return (
    subscriptionPartner !== null &&
    subscriptionPartner !== undefined &&
    resellers.includes(subscriptionPartner.toLowerCase())
  );
};

export const isAdmin = ({
  currentAccount,
  currentMerchant,
}: {
  currentAccount: any;
  currentMerchant: any;
}): boolean =>
  currentAccount?.organization_admin ||
  currentAccount?.roles
    .filter(({ merchant: { id } }: any) => id === currentMerchant.id)
    .reduce(
      (acc: any, { name }: any) => acc || ['admin'].includes(name),
      false
    ) ||
  false;
